import { useCheckRelations } from "components/common";
import { AuthEnums } from "models/enums";

function useAdvisorPermissions() {
  const { hasRelation } = useCheckRelations();

  const isAdvisor = hasRelation(AuthEnums.PersonCompanyRelationType.Advisor, true);

  return { isAdvisor, advisorViewsAvailable: isAdvisor };
}

export default useAdvisorPermissions;
